<template>
  <div>
    <form-label>{{label}}</form-label>
    <vx-input-group v-if="isTemplateSlotDefined" class="mb-base">
      <vs-input :disabled="disabled" :placeholder="placeholder" color="dark" :value="value" :name="name" v-on:input="updateInput" class="w-full" />
      <template :slot="templateSlot">
        <div class="append-text bg-grey-dark">
          <span>{{templateLabel}}</span>
        </div>
      </template>
    </vx-input-group>

    <vs-input
      v-else
      :disabled="disabled"
      :icon="icon"
      :success="success"
      :success-text="successText"
      :warning="warning"
      :warning-text="warningText"
      icon-after="true"
      :placeholder="placeholder"
      color="dark"
      :value="value"
      :name="name"
      v-on:input="updateInput"
      class="w-full"
    />
  </div>
</template>

<script>
import { FormLabel } from "../../../shared/components";

export default {
  //inject: ["$validator"],
  name: "validated-input",
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      default: "",
      type: [String, Number]
    },
    name: {
      default: "",
      type: String
    },
    templateSlot: {
      default: "",
      type: String
    },
    templateLabel : {
      default: "",
      type: String
    },
    disabled : {
      type: Boolean,
      default : false
    },
    placeholder : {
      default: "",
      type: String
    },
    icon : {
      default: "",
      type: String
    },
    success : {
      default: false,
      type: Boolean
    },
    successText : {
      default: "",
      type: String
    },
    warning : {
      default: false,
      type: Boolean
    },
    warningText : {
      default: "",
      type: String
    }
  },
  components: {
    FormLabel
  },
  methods: {
    updateInput(value) {
      this.$emit("input", value);
    }
  },
  computed: {
    isTemplateSlotDefined() {
      return this.templateSlot !== "";
    }
  }
};
</script>